module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0811cf7fc2cb22f4e54d6cb59101ec0a.png";